export default "__VITE_ASSET__Drr3kuHz__"